module.exports = __webpack_public_path__ + "img/details_6.b98263ab.jpg";